module.exports = __webpack_public_path__ + "static/media/french-fries.9617db65.svg";